import { render, staticRenderFns } from "./shiCeShuJu.vue?vue&type=template&id=394bab67&scoped=true&"
import script from "./shiCeShuJu.vue?vue&type=script&lang=js&"
export * from "./shiCeShuJu.vue?vue&type=script&lang=js&"
import style0 from "./shiCeShuJu.vue?vue&type=style&index=0&id=394bab67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394bab67",
  null
  
)

export default component.exports